<template>
    <div>
     <headerNav title="新人奖励卡"/>
     <div   v-for="item in list"
  :key="item.id">
      <van-card
  :desc="'过期时间 '+item.endTime"
  :title="item.name"
  thumb="https://img.yzcdn.cn/vant/ipad.jpeg"
v-for="p in item.newcomerAwardRecordProducts" :key="p.id"

>
  <template #tags>
  <span>状态 {{new Date().toISOString()>item.endTime?'已过期':item.isUse?'已使用':'未使用'}}</span>
   <p style="margin-bottom:5px"  @click="godetail(p)">
    <van-tag plain type="danger">{{p.productName}}</van-tag>
    <div>
     <van-tag plain type="danger">原价  {{p.product.vantSku.price}}元   现价   {{p.price}}元</van-tag>
    </div>
    </p>
  </template>
    </van-card>
     </div>
   
    </div>
</template>
<script>
export default {
    data() {
        return {
            list:[]
        }
    },
    created() {
        this.ajax.post('/api/services/app/PhoneUser/QueryMyNewAwards').then(x=>{
this.list=x.result;
        })
    },
    methods: {
        godetail(item)
    {
        
        var productsku=item.productSku;
        this.$router.push({path:'/product/'+productsku});
    }
    },
}
</script>
<style scoped>

</style>